import React from "react";
import { BookOpenIcon, PlusIcon } from "@heroicons/react/24/outline";
import { Button } from "@/components";
import type { EmptyStoriesStateProps } from "./emptyStoriesState.types";

export default function EmptyStoriesState({ onAddStory }: EmptyStoriesStateProps) {
  return (
    <div className="text-center py-8 border-2 border-dashed border-gray-200 rounded-lg">
      <BookOpenIcon className="h-12 w-12 mx-auto text-gray-400 mb-3" />
      <h3 className="text-sm font-medium text-gray-900 mb-2">
        Nenhuma story criada ainda
      </h3>
      <p className="text-sm text-gray-500 mb-4">
        Adicione user stories para definir as funcionalidades do projeto
      </p>
      <Button
        onClick={onAddStory}
        leftIcon={<PlusIcon className="h-4 w-4" />}
        size="sm"
      >
        Criar Primeira Story
      </Button>
    </div>
  );
}